import * as types from './types'

/**
 * @function: 添加选中商品
 * @author gxl
 * @param  data {object} 请求参数
 * @return: {object}
 */
export const saveSelectGoods = ({ commit }, data) => {
  commit(types.SAVE_SELECT_GOODS, data)
}

/**
 * @function 删除选中商品
 * @author gxl
 * @param commit
 * @param data
 */
export const deleteSelectGoods = ({ commit }, data) => {
  commit(types.DELETE_SELECT_GOODS, data)
}

/**
 * @function 更新选中商品
 * @param commit
 * @param data
 */
export const updateSelectGoods = ({ commit }, data) => {
  commit(types.UPDATE_SELECT_GOODS, data)
}
/**
 * @function 清空选中的商品
 * @param commit
 * @param data
 */
export const clearSelectGoods = ({ commit }, data) => {
  commit(types.CLEAR_SELECT_GOODS, data)
}

/**
 * @function 保存选中的门店信息
 * @param commit
 * @param data
 */
export const saveSelectStoreInfo = ({ commit }, data) => {
  commit(types.SAVE_SELECT_STORE, data)
}

/**
 * @function 判断是否从store获取门店数据
 * @param commit
 * @param data
 */
export const judgeGoodListInfo = ({ commit }, data) => {
  commit(types.JUDGE_GET_GOOD_LIST, data)
}

/**
 * @function 保存活动文本内容
 * @param commit
 * @param data
 */
export const saveGroupBuyActivityContent = ({ commit }, data) => {
  commit(types.SAVE_GROUP_BUY_CONTENT, data)
}

/**
 * @function 保存活动内容
 * @param commit
 * @param data
 */
export const saveGroupBuyActivity = ({ commit }, data) => {
  commit(types.SAVE_GROUP_BUY_ACTIVITY, data)
}

/**
 * @function 保存选中门店id
 * @param commit
 * @param data
 */
export const saveGroupBuyActivityStoreInfo = ({ commit }, data) => {
  commit(types.SAVE_GROUP_BUY_ACTIVITY_STORE_INFO, data)
}
/**
 * @function 清空所有信息
 * @param commit
 * @param data
 */
export const clearGroupBuyAllActivityInfo = ({ commit }) => {
  commit(types.CLEAR_GROUP_BUY_ALL_INFO)
}

/**
 * @function 保存活动列表当前选中的tab状态
 * @param commit
 * @param data
 */
export const setGroupBuyActivityState = ({ commit }, data) => {
  commit(types.SET_GROUPBUY_ACTIVITY_STATE, data)
}

/**
 * @function 保存活动详情状态
 * @param commit
 * @param data
 */
export const setGroupBuyDetailActivityState = ({ commit }, data) => {
  commit(types.SET_GROUPBUY_DETAIL_ACTIVITY_STATE, data)
}

/**
 * @function 订单页是否从扫码点单核销页返回的
 * @param commit
 * @param data
 */
export const setIsBackGeneralCode = ({ commit }, data) => {
  commit(types.SET_IS_BACK_GENERAL_CODE, data)
}
